import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { ReservationStore } from '../service/reservation-store';
import { DateRoomType } from '../models/date-room-type';
import { OverviewStore } from '../service/overview.store';

@Injectable()
export class OverviewResolver implements Resolve<any> {
  constructor(private overviewStore: OverviewStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DateRoomType> {
    const id = route.params[ 'id' ];
    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_OVERVIEW'));
    }

    return this.overviewStore.loadDateRoomTypeSummary(id);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/overview/overview.resolver.ts